import VueRouter from "vue-router"

import { ModulesEnum, TextEnum } from "./constants"

import { UsuarioService } from "./services"
import { Storage, Validator } from "./util"
import Environment from './services/Environment'
import RoutesEnum from './constants/routesEnum'

const noAccessMessage = "No tienes acceso a este módulo"
const activeSessionMessage = "La sesion esta activa"

const routes = [
    ...RoutesEnum.getRoutes(),
    {
        path: "/",
        redirect: "/home"
    },
    {
        path: "*",
        redirect: "/home"
    }
]

const startedSession = () => {
    return Validator.isNotNull(UsuarioService.getUsuario())
}

const setRequestedRoute = (route) => {
    Storage.setObject(TextEnum.REQUESTED_ROUTE, route)
}

const getRequestedRoute = () => {
    return Storage.getObject(TextEnum.REQUESTED_ROUTE)
}

const goRequestedRoute = () => {
    const route = Storage.getObject(TextEnum.REQUESTED_ROUTE)
    console.info("route: ", route)
    Storage.remove(TextEnum.REQUESTED_ROUTE)
    AppRouter.push({
        name: route.name,
        params: route.params,
    })
}

const setVersion = (version) => {
    Storage.setValue(TextEnum.VERSION, version)
}

const getVersion = () => {
    return Storage.getValue(TextEnum.VERSION)
}

const goLogin = () => {
    AppRouter.push({
        name: RoutesEnum.Login.name,
    })
}

const goHome = () => {
    AppRouter.push({
        name: RoutesEnum.ProveedorOrdenCompra.name,
    })
}

const isProveedor = () => {
    return Validator.isNotNull(UsuarioService.getUsuario().pve_id)
}

const getModulesFromSession = () => {
    let modules = []
    UsuarioService
        .getUsuario()
        .modulo_grupos
        .forEach(modulo_grupo => {
            modulo_grupo.modulos.forEach(modulo => {
                modules.push(modulo.mod_codigo)
            })
        })
    return modules
}

const AppRouter = new VueRouter({
    mode: "history",
    routes
})

AppRouter.beforeEach((to, from, next) => {
    // obteniendo valores para la validación de la ruta
    const { path: _path, meta: _meta, name: _to, params } = to
    const { name: _from, fullPath: _fullPath2 } = from
    const { module: _module } = _meta
    console.info("_from: ", _from)
    console.info("_to: ", _to)
    console.info("params: ", params)
    // redireccionando a las vistas de login o crear cuenta
    if (_to == RoutesEnum.Login.name || _to == RoutesEnum.CrearCuenta.name) {
        next()
        return
    }
    // si no hay iniciada una sesion se redireccionará al login
    if (!startedSession()) {
        setRequestedRoute(to)
        goLogin()
        return
    }
    // si no existe una version registrada
    if (getVersion() == null) {
        setVersion(Environment.version)
    }
    // si existe una sesion y una version:
    // - si son iguales continua con el procedimiento
    // - si son diferentes debe destruir todo dato de sesion y redireccionar al login
    console.info("getVersion(): ", getVersion())
    console.info("Environment.version: ", Environment.version)
    if (getVersion() != Environment.version) {
        setVersion(Environment.version)
        UsuarioService.removeData()
        setRequestedRoute(_to)
        goLogin()
        return
    }
    // si existe una ruta solicitada, pero se necesito iniciar sesion PromiseRejectionEvent,
    // esta función es para recuperar dicha ruta y dirigirse a ella
    if (getRequestedRoute() != null) {
        goRequestedRoute()
        return
    }
    // si desea ir al home verifica si el usuario es un proveedor para
    // redireccionarlo a la vista de ordenes de compra
    if (_module == ModulesEnum.HOME) {
        if (isProveedor()) {
            goHome()
        }
        // redireccionando al home
        next()
        return
    }

    let modules = getModulesFromSession()
    if (modules.some(module => module == _module)) {
        next()
        return
    }

})

export default AppRouter